import { Button } from 'blaze-ui/Button'
import { Audio } from '../../icons/Audio'
import Styles from './DropZone.module.scss'
import { Upload } from 'blaze-ui/icons'
import { useRef, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import cx from 'classnames'
import { Video } from '../../icons/Video'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  inputType: 'audio' | 'video'
  onDrop: (files: File[]) => void
}

export const DropZone = ({ inputType, onDrop }: Props) => {
  const [isDragOver, setIsDragOver] = useState(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const { isMobile } = useResponsiveDesign()

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    onDragEnter: () => setIsDragOver(true),
    onDragLeave: () => setIsDragOver(false),
    accept: inputType === 'audio' ? 'audio/*' : 'video/*',
  })

  const handleButtonClick = () => {
    fileInputRef.current?.click() // Trigger the hidden file input when the button is clicked
  }

  return (
    <div
      {...getRootProps()}
      className={cx(Styles.dropzone, {
        [Styles.dragOver]: isDragOver,
      })}
    >
      <input {...getInputProps()} ref={fileInputRef} style={{ display: 'none' }} />

      <div className={Styles.details}>
        {inputType === 'audio' ? <Audio size={58} /> : <Video size={58} />}
        <span className={Styles.text}>
          {inputType === 'audio'
            ? 'Drag & drop your audio file (MP3, M4A, WAV) here'
            : 'Drag & drop your video file (MP4, MOV, AVI) here'}
        </span>
      </div>
      <Button frontIcon={Upload} onPress={handleButtonClick}>
        {isMobile ? 'Select file from mobile' : 'Select file from your computer'}
      </Button>
    </div>
  )
}
